import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { motion } from "framer-motion";
import { Slide, Zoom } from 'react-awesome-reveal';
import { Helmet } from "react-helmet-async";
import "../Styles/Career.css";


const jobs = [
    // {
    //     title: "Pre-checks Specialist",
    //     category: "Pre-checks",
    //     remote: true,
    //     type: "Full-time",
    //     description:
    //         "Responsible for initial project validations, reviewing compliance documents, and coordinating with UK teams to ensure pre-requisites are met.",
    // },
    // {
    //     title: "Submission Officer",
    //     category: "Submission",
    //     remote: true,
    //     type: "Full-time",
    //     description:
    //         "Manage all tasks leading to project submission including documentation, quality control, verification of previous work, and final compilation for UK office.",
    // },
    // {
    //     title: "Assessment Coordinator",
    //     category: "Assessment",
    //     remote: true,
    //     type: "Full-time",
    //     description:
    //         "Handles EPR reporting, organizes assessment phases, and coordinates live installation checks for submitted projects.Handles EPR reporting, organizes assessment phases, and coordinates live installation checks for submitted projects.Handles EPR reporting, organizes assessment phases, and coordinates live installation checks for submitted projects.",
    // },
    // {
    //     title: "Project Handling Executive",
    //     category: "Project Handling",
    //     remote: true,
    //     type: "Full-time",
    //     description:
    //         "Oversees project timelines, manages deliverables, communicates with UK counterparts, and ensures smooth execution from approval to finalization.",
    // },
    // {
    //     title: "Coordination & Cost Analyst",
    //     category: "Co-ordination",
    //     remote: true,
    //     type: "Full-time",
    //     description:
    //         "Involved in inter-team coordination, analyzing project cost structures, and categorizing job types for smooth financial and operational planning.",
    // },
];

const filters = [
    "View all",
    "Pre-checks",
    "Submission",
    "Assessment",
    "Project Handling",
    "Co-ordination",
];

const Career = () => {
    const text = "Join our team and help shape the future. At Paramount Green Servcies, we value innovation, collaboration, and growth. Explore exciting opportunities and make an impact every day.".split("");
    const [activeFilter, setActiveFilter] = useState("View all");
    const [expanded, setExpanded] = useState(false);
    const [expandedJob, setExpandedJob] = useState(null); // store index of expanded job

    const filteredJobs = activeFilter === "View all"
        ? jobs
        : jobs.filter((job) => job.category === activeFilter);

    return (
        <>
            <Helmet>
                <title>Join Our Team || Paramount Green Services</title>
                <meta name="description" content="Free heating, insulation, and solar panel grants across the UK. Transform your home’s energy efficiency today." />
            </Helmet>
            <div className="career-container">
                {/* Hero Section */}
                <section className="career-hero">
                    <div className="hero-text">
                        <div className="badge">Career & Jobs Website</div>
                        <Fade><h2>Your Bridge to a <em>Dream Career.</em></h2></Fade>
                        <p className="mt-3">
                            {text.map((char, index) => (
                                <motion.span
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.01 }}
                                >
                                    {char}
                                </motion.span>
                            ))}
                        </p>

                        <div className="search-bar">
                            <input type="text" placeholder="Search For a Job..." />
                            <button>Search</button>
                        </div>

                        <div className="popular-tags">
                            <span>Popular Jobs:</span>
                            <button>Data Handling</button>
                            <button>Project Handling</button>
                            <button>Submission</button>
                        </div>

                        {/* <div className="stats">
                            <div className="stat-box"><strong>78K+</strong><span>Career & Jobs</span></div>
                            <div className="stat-box"><strong>12+</strong><span>Year Experience</span></div>
                            <div className="stat-box rating">
                                <strong>4.9</strong><span>/5.0</span>
                                <p>Lorem Ipsum</p>
                            </div>
                        </div> */}
                    </div>

                    <div className="hero-image">
                        <img src="https://d2ms8rpfqc4h24.cloudfront.net/hustle_faster_innovate_better_with_devops_as_a_service_1ffdbb1447.png" alt="Career girl" />
                    </div>
                </section>

                {/* Job Listings Section */}
                <section className="job-listings">
  <div className="section-header">
    <button className="hiring-badge">We’re hiring!</button>
    <h2>Be part of our mission</h2>
    <p>We’re looking for passionate people to join us on our mission. We value flat hierarchies, clear communication, and full ownership and responsibility.</p>
  </div>

  <div className="job-filters">
    {filters.map((filter) => (
      <button
        key={filter}
        className={filter === activeFilter ? "active" : ""}
        onClick={() => setActiveFilter(filter)}
      >
        {filter}
      </button>
    ))}
  </div>

  <Fade>
    {filteredJobs.length > 0 ? (
      filteredJobs.map((job, index) => (
        <div className="job-card" key={index}>
          <div className="job-content">
            <h3>{job.title}</h3>
            <p>
              {expandedJob === index
                ? job.description
                : `${job.description.slice(0, 100)}...`}
              <button
                onClick={() =>
                  setExpandedJob(expandedJob === index ? null : index)
                }
                className="read-more"
              >
                {expandedJob === index ? "Show less" : "Read more"}
              </button>
            </p>
            <div className="job-tags">
              <span>{job.remote ? "100% remote" : "On-site"}</span>
              <span>{job.type}</span>
            </div>
          </div>
          <div className="job-apply">
            <a href="#">Apply ↗</a>
          </div>
        </div>
      ))
    ) : (
      <div className="no-jobs">
        <h4>No jobs available</h4>
        <p>Please check back later or try another category.</p>
      </div>
    )}
  </Fade>
</section>

            </div>
        </>
    );
};

export default Career;
